<template>
    <role-assignment/>
</template>

<script>
import RoleAssignment from '@/ui/role-assignment';

export default {
    components: {
        RoleAssignment,
    },
};
</script>

<style module lang="less">
@import "~style";
</style>



// WEBPACK FOOTER //
// details.vue?52d25104